import { render, staticRenderFns } from "./CampusContent.vue?vue&type=template&id=83fa7e0c&scoped=true&"
import script from "./CampusContent.vue?vue&type=script&lang=js&"
export * from "./CampusContent.vue?vue&type=script&lang=js&"
import style0 from "./CampusContent.vue?vue&type=style&index=0&id=83fa7e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83fa7e0c",
  null
  
)

export default component.exports